import useApiRecord from "hooks/use_api_record"
import { fields, include } from "components/admin/registerable/requestParams"

const useRegistration = (id, data = {}) => {
  const path = "registrations"

  const attendeeFields = [
    ...fields.Attendee.split(","),
    ...["assignment_types", "assignment_areas"]
  ]

  const eventFields = [...fields.Event.split(","), ...["assignment_areas", "assignment_types"]]

  const defaultData = {
    fields: {
      ...fields,
      Registration: [
        "answers",
        "attendee_type_selections",
        "attendees",
        "canceled_on",
        "created_at",
        "created_by_name",
        "event",
        "has_balance_due",
        "is_canceled",
        "is_deletable",
        "questions",
        "refund_due",
        "total_cost_minus_discounts",
        "total_due",
        "total_payments",
        "total_refunds",
        "responsible_person",
        "updated_at"
      ].join(),
      Question: [
        "allow_multiple",
        "choices",
        "description",
        "kind",
        "position",
        "question_group",
        "required",
        "text"
      ].join(),
      Attendee: attendeeFields.join(),
      Event: eventFields.join(),
      Answer: ["answers", "kind", "multiple_select", "question"].join(),
      AssignmentType: ["name"].join(),
      AssignmentArea: ["name", "assignment_type"].join()
    },
    include: [
      ...include,
      "answers",
      "attendees.assignment_types",
      "attendees.assignment_areas",
      "event.assignment_types",
      "event.assignment_areas",
      "questions"
    ]
  }

  const { loading, errors, record, setRecord } = useApiRecord({
    id,
    path,
    data: { ...defaultData, ...data }
  })

  return { loading, errors, registration: record, setRegistration: setRecord }
}

export default useRegistration
